import styled from "styled-components";

export const OnePictureDiv = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`;

export const IntroImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
`;
